const hyperlink_contact_us          = "https://linktr.ee/atsiridisarinah"
const hyperlink_qiscus              = "https://linktr.ee/atsiridisarinah"
const hyperlink_table_layout        = "https://linktr.ee/atsiridisarinah"
const hyperlink_whatsup             = "https://shorturl.at/cHNO8"
export default {
    CONTACT_US: hyperlink_contact_us,
    QISCUS: hyperlink_qiscus,
    TABLE_LAYOUT: hyperlink_table_layout,
    WA: hyperlink_whatsup
}